export default __webpack_public_path__ + "static/media/pr_c_24.c15b2f14.jpg";